import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CourseService {
    constructor(private http: CustomHttpService) { }

    getAllCourses(params: any): Observable<any> {
        return this.http.post(environment.getAllCourses, params);
    }

    createCourse(data: any): Observable<any> {
        return this.http.post(environment.createCourse, data);
    }

    updateCourse(data: any): Observable<any> {
        return this.http.post(environment.updateCourse, data);
    }

    deleteCourse(data: any): Observable<any> {
        return this.http.post(environment.deleteCourse, data);
    }

    findAndCountAllCourses(params: any): Observable<any> {
        return this.http.post(environment.findAndCountAllCourses, params);
    }
}